import { extendTheme } from '@chakra-ui/react'

// BEXCO 브랜드 컬러 팔레트
const colors = {
  bexco: {
    50: '#e6f3ff',
    100: '#b3d9ff',
    200: '#80bfff',
    300: '#4da6ff',
    400: '#1a8cff',
    500: '#0066cc', // 메인 브랜드 컬러
    600: '#0052a3',
    700: '#003d7a',
    800: '#002952',
    900: '#001429',
  },
  gray: {
    50: '#f7fafc',
    100: '#edf2f7',
    200: '#e2e8f0',
    300: '#cbd5e0',
    400: '#a0aec0',
    500: '#718096',
    600: '#4a5568',
    700: '#2d3748',
    800: '#1a202c',
    900: '#171923',
  }
}

const fonts = {
  heading: "'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  body: "'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
}

const components = {
  Button: {
    baseStyle: {
      fontWeight: 'semibold',
      borderRadius: 'md',
    },
    variants: {
      solid: {
        bg: 'bexco.500',
        color: 'white',
        _hover: {
          bg: 'bexco.600',
        },
        _active: {
          bg: 'bexco.700',
        },
      },
      outline: {
        borderColor: 'bexco.500',
        color: 'bexco.500',
        _hover: {
          bg: 'bexco.50',
        },
      },
    },
  },
  Card: {
    baseStyle: {
      container: {
        borderRadius: 'lg',
        boxShadow: 'sm',
        border: '1px solid',
        borderColor: 'gray.200',
      },
    },
  },
  Input: {
    variants: {
      filled: {
        field: {
          bg: 'gray.50',
          _hover: {
            bg: 'gray.100',
          },
          _focus: {
            bg: 'white',
            borderColor: 'bexco.500',
          },
        },
      },
    },
  },
}

const theme = extendTheme({
  colors,
  fonts,
  components,
  styles: {
    global: {
      body: {
        bg: 'gray.50',
        color: 'gray.800',
      },
    },
  },
})

export default theme






